"use client";
import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import USAMapSVG from "./USAMap";

export default function USMap({ locations, preSelectedState = null }) {
  console.log("🚀 ~ USMap ~ locations:", locations)
  const router = useRouter();
  const [loading, setloading] = useState(false);
  const [selectedState, setSelectedState] = useState(preSelectedState);

  // Set selected state when preSelectedState changes
  useEffect(() => {
    if (preSelectedState) {
      setSelectedState(preSelectedState);
    }
  }, [preSelectedState]);

  const handleStateClick = (stateSlug) => {
    // If we're on a state page, disable all state clicks
    if (preSelectedState) {
      // return;
    }
    console.log("🚀 ~ handleStateClick ~ stateSlug:", stateSlug);
    // If we're on the main service-area page, navigate to the state page
    if (stateSlug) {
      setloading(true);
      router.push(`/service-area/${stateSlug}?#map`);
    }

    // On the main service-area page, toggle state selection (original behavior)
    if (stateSlug === selectedState) {
      setSelectedState(null);
    } else {
      setSelectedState(stateSlug);
    }
  };

  const sortLocations = (locations) => {
    return locations
      .map((location) => ({
        ...location,
        locations: location.locations.sort((a, b) =>
          a.title.localeCompare(b.title)
        ),
      }))
      .sort((a, b) => a.state.localeCompare(b.state));
  };

  const randKeyGenerate = () => {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  };

  const sortedLocations = sortLocations(locations || []);
  const filteredLocations = selectedState
    ? sortedLocations.filter((loc) => loc.state_slug === selectedState)
    : sortedLocations;

  return (
    <>
      <div className="flex relative pb-8 justify-center mb-8" id='map'>
    {loading && <div className=" absolute inset-0  z-50 flex items-center justify-center z-50">
        <div className="animate-spin rounded-full h-20 w-20 border-4 border-gray-50 border-t-brand"></div>
      </div>}
      

        <USAMapSVG
          locations={locations}
          selectedState={selectedState}
          onStateClick={handleStateClick}
        // disableClicks={preSelectedState !== null}
        />
      </div>
      <div className="flex flex-col">
        {filteredLocations.length === 0 ? (
          <div className="text-center font-bold text-lg text-gray-900">
            No locations available for the selected state.
          </div>
        ) : (
          <>
          
            {selectedState ? (
              <div className="w-full">
                {filteredLocations.map((location) => (
                  <div key={location.state_slug} className="location-item">
                    <div>
                      {preSelectedState ? (
                        // On state page, just show the non-clickable heading
                        <h3 className="text-lg font-bold font-jost mb-2">
                          {location.state}
                        </h3>
                      ) : (
                        // On main service-area page, make it clickable even when selected
                        <Link
                          href={`/service-area/${location.state_slug}`}
                          className="text-lg font-bold font-jost mb-2 block hover:text-brand cursor-pointer"
                        >
                          {location.state}
                        </Link>
                      )}
                      <ol className="pl-2 gap-4 columns-1 sm:columns-2 lg:columns-3">
                        {location.locations.map((loc) => (
                          <li key={loc.slug}>
                            <a
                              href={`/service-area/${location.state_slug}/${loc.slug}`}
                              className="block px-2 py-1 text-brand"
                            >
                              {loc.title}
                            </a>
                          </li>
                        ))}
                      </ol>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <ol className="pl-2 gap-4 columns-1 sm:columns-2 lg:columns-3">
                {filteredLocations.map((location) => (
                  <React.Fragment key={randKeyGenerate()}>
                    <li>
                      <Link
                        href={`/service-area/${location.state_slug}`}
                        className="text-lg font-bold font-jost mb-2 block hover:text-brand cursor-pointer"
                      >
                        {location.state}
                      </Link>
                    </li>
                    {location.locations.map((loc) => (
                      <li key={randKeyGenerate()}>
                        <a
                          href={`/service-area/${location.state_slug}/${loc.slug}`}
                          className="block px-2 py-1 text-brand"
                        >
                          {loc.title}
                        </a>
                      </li>
                    ))}
                  </React.Fragment>
                ))}
              </ol>
            )}
          </>
        )}
      </div>
    </>
  );
}
